import path from 'path';
import fs from 'fs-extra';
import { TemplateConfig } from '../types/index.js';
import { readJson } from '../utils/file.js';
import inquirer from 'inquirer';

/**
 * 模板渲染器
 */
export class TemplateRenderer {
  /**
   * 读取模板配置
   */
  async readTemplateConfig(
    projectPath: string
  ): Promise<TemplateConfig | null> {
    const configPath = path.join(projectPath, 'template.json');
    return await readJson<TemplateConfig>(configPath);
  }

  /**
   * 收集用户输入
   */
  async collectAnswers(
    templateConfig: TemplateConfig,
    projectName: string
  ): Promise<Record<string, any>> {
    const answers: Record<string, any> = {
      projectName,
    };

    if (!templateConfig.prompts || templateConfig.prompts.length === 0) {
      return answers;
    }

    const promptAnswers = await inquirer.prompt(
      templateConfig.prompts.map((q) => ({
        ...q,
        default: q.default,
      }))
    );

    return { ...answers, ...promptAnswers };
  }

  /**
   * 删除模板配置文件
   */
  async removeTemplateConfig(projectPath: string): Promise<void> {
    const configPath = path.join(projectPath, 'template.json');
    const exists = await fs.pathExists(configPath);
    if (exists) {
      await fs.remove(configPath);
    }
  }
}

export const templateRenderer = new TemplateRenderer();

